var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10602",
    "data-name": "Group 10602",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.387,
    height: 55.364,
    viewBox: "0 0 55.387 55.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4783",
    "data-name": "Rectangle 4783",
    width: 55.387,
    height: 55.364,
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10601",
    "data-name": "Group 10601",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78853",
    "data-name": "Path 78853",
    d: "M6.894,55.476H0c.006-.2.016-.4.016-.607q0-26.926,0-53.852V.129h41.47v6.9H25.431v4.617H41.5v4.6H25.447v4.625H41.492v4.611H25.451v4.612H41.487V34.7H25.458v4.63H41.506v6.907H20.836v4.623H41.5v4.612H16.22V46.269H6.938c0,.305,0,.57,0,.834q-.022,4.186-.044,8.373M11.522,7.007c-1.439,0-2.827-.013-4.214.022-.127,0-.346.306-.353.477-.036.875-.017,1.752-.017,2.629,0,.482,0,.965,0,1.456h4.584Zm-.014,18.5H6.982v4.544h4.526ZM20.77,7.053H16.229v4.528H20.77ZM6.989,20.836h4.528V16.292H6.989ZM11.515,34.71H6.987v4.544h4.528Zm4.7-13.885h4.537V16.3H16.218Zm4.545,4.684H16.234v4.537h4.529ZM16.241,39.23h4.516V34.715H16.241Z",
    transform: "translate(0 -0.112)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78854",
    "data-name": "Path 78854",
    d: "M344.638,94.508c-.94-.474-1.749-.914-2.588-1.286a1.162,1.162,0,0,0-.844,0c-.852.376-1.676.819-2.611,1.288.166-.938.281-1.758.464-2.564a1,1,0,0,0-.348-1.122c-.646-.553-1.247-1.157-1.97-1.838,1.024-.15,1.918-.3,2.817-.406a.9.9,0,0,0,.807-.578c.369-.793.795-1.559,1.256-2.45.416.812.83,1.518,1.145,2.267a1.183,1.183,0,0,0,1.1.794c.827.083,1.649.218,2.651.356-.631.6-1.141,1.149-1.725,1.609a1.4,1.4,0,0,0-.562,1.679,21.2,21.2,0,0,1,.408,2.253",
    transform: "translate(-291.13 -73.963)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78855",
    "data-name": "Path 78855",
    d: "M344.613,265.674c-.892-.446-1.7-.821-2.474-1.25a.96.96,0,0,0-1.055-.013c-.78.434-1.591.813-2.507,1.273.155-.906.242-1.7.439-2.471a1.153,1.153,0,0,0-.451-1.335c-.618-.509-1.178-1.089-1.852-1.723.994-.145,1.854-.307,2.721-.382a1.04,1.04,0,0,0,.955-.687c.361-.771.772-1.518,1.206-2.361.436.849.856,1.611,1.222,2.4a.979.979,0,0,0,.91.642c.869.076,1.732.235,2.757.382-.722.681-1.326,1.294-1.98,1.85a.988.988,0,0,0-.348,1.114c.184.8.294,1.624.457,2.561",
    transform: "translate(-291.107 -221.953)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78856",
    "data-name": "Path 78856",
    d: "M341.6,342.319c.447.871.869,1.615,1.215,2.393a1.045,1.045,0,0,0,.978.661c.845.087,1.685.224,2.7.363-.736.693-1.345,1.3-1.993,1.863a.957.957,0,0,0-.354,1.054c.182.808.3,1.63.474,2.617-.856-.429-1.619-.768-2.336-1.185a1.216,1.216,0,0,0-1.365,0c-.715.41-1.471.751-2.338,1.187.163-.939.27-1.754.455-2.551a1.047,1.047,0,0,0-.381-1.174c-.632-.536-1.218-1.126-1.937-1.8.982-.141,1.832-.286,2.688-.377a1.055,1.055,0,0,0,.974-.669c.35-.776.772-1.52,1.22-2.386",
    transform: "translate(-291.113 -295.953)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78857",
    "data-name": "Path 78857",
    d: "M346.536,174.573c-.759.714-1.434,1.3-2.046,1.953a1.21,1.21,0,0,0-.29.86c.1.867.29,1.723.47,2.718-.838-.422-1.607-.758-2.321-1.186a1.239,1.239,0,0,0-1.416.015c-.717.413-1.475.756-2.314,1.178.166-.935.283-1.776.473-2.6a1,1,0,0,0-.376-1.112c-.643-.551-1.241-1.153-1.947-1.816,1.052-.155,1.98-.269,2.9-.445a1.064,1.064,0,0,0,.65-.45c.459-.8.858-1.627,1.328-2.538.457.89.847,1.715,1.3,2.5a1.146,1.146,0,0,0,.693.483c.9.178,1.82.283,2.9.44",
    transform: "translate(-291.155 -147.968)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78858",
    "data-name": "Path 78858",
    d: "M338.613,8.957c.158-.92.246-1.723.446-2.5a1.115,1.115,0,0,0-.43-1.28c-.614-.521-1.179-1.1-1.873-1.755.931-.134,1.737-.28,2.549-.357a1.229,1.229,0,0,0,1.174-.8c.311-.742.726-1.44,1.151-2.264.442.853.87,1.6,1.221,2.39a1.01,1.01,0,0,0,.91.65c.865.1,1.727.228,2.763.368-.729.691-1.332,1.3-1.982,1.864a.994.994,0,0,0-.349,1.116c.185.8.293,1.624.455,2.561-.921-.465-1.723-.906-2.558-1.27a1.266,1.266,0,0,0-.912,0c-.836.365-1.639.807-2.565,1.275",
    transform: "translate(-291.144)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp10);
export default __webpack_public_path__ + "static/media/exp-10.12a136df7e300a7213d08a73b289b16d.svg";
export { ForwardRef as ReactComponent };